export default "__VITE_ASSET__BQJSYCA2__"